import { IonModal } from '@ionic/react'
import React from 'react'
import './index.scss'

interface IModalProps {
  title?: string;
  des?: string;
  btnTitle?: string;
  btnDes?: string;
  children?: any;
  reject?: () => void;
  resolve?: () => void;
}

const ResultAlert: React.FC<IModalProps> = (props: IModalProps) => {
  const { title, des, btnTitle, btnDes, reject, resolve, children } = props
  return (
    <IonModal
      cssClass='get-result-alert'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <i className='iconfont icon-close' data-cypid='getResultAlertClose' onClick={reject}></i>
        {
          title &&
            <div className='title'>{title}</div>
        }
        <div className='main'>{children}</div>
        <div className='footer'>
          <div className='modal-btn' data-cypid='getResultAlertConfirm' onClick={resolve}>
            <div>{btnTitle || i18n.t('common.ok')}</div>
            {
              btnDes &&
                <div className='btn-des'>{btnDes}</div>
            }
          </div>
        </div>
        {
          des &&
            <div className='des-main'>{des}</div>
        }
      </div>
    </IonModal>
  )
}

export default ResultAlert
